import React, { useEffect, useRef } from 'react'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { useFormValidation } from '../../../hooks/useFormValidation'
import { buildControlsExt, selectInput } from '../../inputs/controls'
import { IEnumProps } from '../../models/Enum/types'
import { getLabel } from '../../../utils/getLabel'
import { modifyActionParameter } from '../../../store/actions/actionsActions'
import { useDebouncedValue } from '../../../hooks/useDebouncedValue'
import { PATH_JOINER } from '../../models/utils/getConfigBitPath'

export const EnumACTN = (props: IEnumProps) => {
    const { data = {}, dataSchema = {}, name, wrapper, dataPath } = props
    const dispatch = useAppDispatch()

    const {
        name: inputLabel,
        description: tooltipText,
        default: defaultValue,
        options,
    } = dataSchema

    const optionKeys = useRef(Object.keys(options ?? {}))
    const path = [...(dataPath.split(PATH_JOINER)), name]
    const [inputState, setInputState, touched, setTouched] = useFormValidation(
        data,
        {}
    )
    const debouncedInputState = useDebouncedValue(inputState, 500)

    const label = getLabel(name, inputLabel)
    const className = !wrapper ? 'w-100 pe-2' : ''

    useEffect(() => {
        dispatch(
            modifyActionParameter({
                path,
                data: inputState,
            })
        )
    }, [debouncedInputState, dispatch])

    const controlDescriptors = [
        selectInput({
            name,
            options: Object.keys(options),
            selected: data?.[name] || defaultValue || optionKeys.current[0],
            tooltipText,
            label,
            className,
            isColumn: true,
        }),
    ]

    const EnumInput = buildControlsExt(
        controlDescriptors,
        inputState,
        setInputState,
        touched,
        setTouched,
    )

    return <div className={`${!wrapper ? 'w-100' : ''}`}>{EnumInput}</div>
}
